import React, { useEffect, useState } from 'react';
import TitleMain from "../../components/Title/TitleMain";
import {useUser} from "../../contexts/UserContext";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faSkull } from '@fortawesome/free-solid-svg-icons';
import styles from './ErrorPage.module.css';
import {Link, useParams} from "react-router-dom";
import Routing from "../../services/routing";

function ErrorPage({title = "Erreur 404", msg = "Oups ! On dirait que vous vous êtes perdu.", lien='/' }) {
    const { user } = useUser();
    const { userstatus } = useParams();

    return (
        <div className="content">
            <TitleMain text={title}/>

            <button className={styles.btnPlayIcon}><FontAwesomeIcon icon={faSkull} className={styles.faSkull}/></button>

            <p className={styles.msgErreur}>
                { msg }
            </p>

            <Link to={ userstatus ? Routing.routes.userStatus : user ? lien : Routing.routes.login} className={styles.linkErreur}>Retour à l'accueil</Link>

        </div>
    )
}

export default ErrorPage;
